import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Decision } from '../../types/decisions';
import Image from '../image/Image';
import './productCart.scss';

interface ProductCartProps {
    product: Decision;
    onCustomProductClick?: (id: number) => void;
}

const isMaria = window.location.hostname.includes('maria');
const appsUrls = {
    decision: '/apps',
    form: '/forms',
    mashup: '/mashups',
};

const ProductCart: React.FC<ProductCartProps> = ({ product, onCustomProductClick }) => {
    const navigate = useNavigate();

    const onProductClick = () => {
        const appUrl = isMaria ? '/virtual-agent' : appsUrls[product.type] || '/apps';
        navigate(`${appUrl}/${product.id}`);
    };

    return (
        <div className="product-cart">
            <Image
                src={product.image}
                alt={product.name}
                className="product-image"
                onClick={onCustomProductClick ? () => onCustomProductClick(product.id) : onProductClick}
            />
            <div className="product-details">
                <p className="product-name" onClick={onProductClick} title={product.name}>{product.name}</p>
                <p className="product-description" title={product.author}>By {product.author}</p>
            </div>
        </div>
    );
};

export default ProductCart;
